"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flatten = void 0;
var flat_1 = require("flat");
Object.defineProperty(exports, "flatten", { enumerable: true, get: function () { return flat_1.flatten; } });
//# sourceMappingURL=flatten.js.map